<script setup lang="ts">
    import { formatNumericText } from '@shared/utils/formatNumericText';
    import FeatureLock from '@shared/components/FeatureLock.vue';
    import type { Question, QuestionFilter, QuestionOption } from '../../SurveysTypes.d';

    const props = defineProps<{
        question: Question;
        questionFilters: QuestionFilter[];
    }>();

    defineEmits<{
        toggleOptionFilter: [option: QuestionOption];
    }>();

    function isOptionInFilter(option: QuestionOption): boolean {
        return props.questionFilters.some((f) => f.QuestionId === props.question.QuestionId && f.QuestionOptionId === option.QuestionOptionId);
    }
</script>

<template>
    <div>
        <blockquote v-for="option in question.QuestionOptions" :key="option.QuestionOptionId" class="answer">
            <p v-html="option.Value"></p>
            <div class="text-noitalic m-xs-t d-flex gap-sm flex-wrap align-items-end">
                <span>
                    {{ $Resources.ResponseCountLabel }}:
                    <strong>
                        {{ option.ResponseCount }}
                        ({{ formatNumericText(option.ResponseCount === 0 ? 0 : (option.ResponseCount / question.ResponseCount) * 100, { suffix: '%' }) }})
                    </strong>
                </span>

                <FeatureLock feature="Forms.AdvancedStatistics" hideWhenLocked>
                    <button
                        v-if="option.ResponseCount > 0"
                        type="button"
                        class="btn btn-default btn-xs m-auto-l hidden-print"
                        @click="$emit('toggleOptionFilter', option)">
                        <template v-if="!isOptionInFilter(option)">
                            <span class="glyphicon glyphicon-filter"></span>
                            {{ $Resources.SurveyAddQuestionOptionFilter }}
                        </template>
                        <template v-else>
                            <span class="glyphicon glyphicon-remove"></span>
                            {{ $Resources.SurveyRemoveQuestionOptionFilter }}
                        </template>
                    </button>
                </FeatureLock>
            </div>
        </blockquote>
    </div>
</template>
